import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './admin-terms.loaders';
import { adminTermsKeys } from './admin-terms.queries';

export const useCreateAdminTerm = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createTerm, {
    onSuccess: () => queryClient.invalidateQueries(adminTermsKeys.all),
  });
};
